export enum Bidders {
    RICHAUDIENCE = "richaudience",
    APPNEXUS = "appnexus",
    TEADS = "teads",
    OGURY = "ogury",
    PUBMATIC = "pubmatic",
    RUBICON = "rubicon",
    TRIPLELIFT = "triplelift",
    CRITEO = "criteo",
    INDEXEXCHANGE = "ix",
    NEXX360 = "nexx360",
    ONETAG = "onetag",
    SMARTADSERVER = "smartadserver",
    MEDIANET = "medianet",
}
